import angular from 'angular';

angular.module('myConsultApp').directive('adminPagination', () => {
  return {
    templateUrl: 'templates/v2/admin-pagination.html',
    restrict: 'E',
    scope: {
      pageData: '=',
      objKey: '@objKey',
      gotoPageFn: '&',
      pageSize: '=',
    },
    link: ($scope) => {
      if (!$scope.pageSize) {
        $scope.pageSize = 15;
      }
      $scope.pagination = {};
      $scope.goToPage = (url) => {
        if (url) {
          $scope.gotoPageFn({ url });
        }
      };

      $scope.goToPageNumber = (pageNumber, base_url) => {
        var url;
        if (base_url.includes('page=')) {
          url = base_url.replace(/(page=)[^\&]+/, '$1' + pageNumber);
        } else {
          url = $scope.goToPage(base_url + '&page=' + pageNumber);
        }
        $scope.goToPage(url);
      };

      $scope.getPages = (data) => {
        const pagination = {
          currentPage: data.meta.current_page,
          base_url: data.meta.base_url,
          count: Math.ceil(data.meta.count / $scope.pageSize),
          displayedPages: [],
          next: data.meta.next,
          previous: data.meta.previous,
        };
        const numbers = [];

        if (pagination.count <= 7) {
          if (pagination.count == 0) {
            numbers.push(1);
          } else {
            for (let i = 1; i <= pagination.count; i++) {
              numbers.push(i);
            }
          }
        } else if (pagination.currentPage >= 1 && pagination.currentPage <= 3) {
          for (let i = 1; i <= 4; i++) {
            numbers.push(i);
          }
          numbers.push('...');
          numbers.push(pagination.count);
        } else if (pagination.currentPage >= pagination.count - 3) {
          numbers.push(1);
          numbers.push('...');
          for (let i = pagination.count - 3; i <= pagination.count; i++) {
            numbers.push(i);
          }
        } else {
          numbers.push(1);
          numbers.push('...');
          numbers.push(pagination.currentPage - 1);
          numbers.push(pagination.currentPage);
          numbers.push(pagination.currentPage + 1);
          numbers.push('...');
          numbers.push(pagination.count);
        }

        pagination.displayedPages = numbers.map((item) => ({
          number: item,
          url:
            item === '...'
              ? ''
              : $scope.getPageNumberUrl('page', pagination.next, pagination.previous, item),
        }));

        return pagination;
      };

      $scope.getPageNumberUrl = (key, next, prev, num) => {
        let url = next;
        if (next === null && prev !== null) {
          url = prev;
        }
        if (!next && !prev) {
          return null;
        }
        let name = key.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        let results = regex.exec(url);
        if (!results) return url;
        if (!results[2]) return '';
        return url.replace(/(page=)[^\&]+/, '$1' + num);
      };

      $scope.checkPage = (page, key) => {
        if ($scope.pagination.count > 7) {
          return false;
        }
        if (key === 'first' && page === 1) {
          return true;
        }
        if (key === 'last' && page === $scope.pagination.count) {
          return true;
        }
        return false;
      };

      $scope.validatePageNumberInput = () => {
        if ($scope.pageNumberInput < 0) {
          $scope.pageNumberInput = 1;
        }
        if ($scope.pageNumberInput > $scope.pagination.count) {
          $scope.pageNumberInput = $scope.pagination.count;
          $scope.pageNumberInputError = `Max page = ${$scope.pagination.count}`;
        } else {
          $scope.pageNumberInputError = '';
        }
      };

      $scope.$watch('pageData', () => {
        if ($scope.pageData !== undefined && Object.keys($scope.pageData).length > 0) {
          $scope.pagination = $scope.getPages($scope.pageData);
        }
      });
    },
  };
});
